<template>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myLargeModalLabel" style="font-size: 14px;">Enviar Contrato al Empleado</h4>
                <button ref="closeSendContractModal" class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="form theme-form">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="mb-3">
                                <label>Enviar a: </label>
                                <input class="form-control" type="text" v-model="form.email" v-bind:class="formSubmitted ? errors.email ? 'is-invalid' : 'is-valid' : ''" placeholder="" @input="form.email = form.email.toLowerCase()">
                                <div class="invalid-feedback" v-if="errors.email">{{ errors.email }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="mb-3">
                                <label>Notificaciones: </label>
                                <input class="form-control" type="text" v-model="notifications_email" placeholder="" @input="notifications_email = notifications_email.toLowerCase()">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary btn-sm" type="button" style="float: right;" title="btn btn-success btn-sm" @click="sendContractEmployeeValidation">Enviar Contrato</button>
            </div>
        </div>
    </div>
</template>
<script>
import ws from '@/services/employees'

import validations from '@/mixins/validations/employeeValidations.js'

export default {
    name: 'employee_send_contract_modal',
    mixins: [validations],
    props: {
        
    },
    components: {
        
    },
    data(){
        return{
            showModal: true,
            employee: null,
            notifications_email: 'raalveco@gmail.com',
        }
    },
    methods: {
        loadEmployee(employee){
            this.employee = employee;

            this.setForm(this.employee);
        },
        async sendContractEmployee(form) {
            if(this.employee.email == "") return;

            this.setForm(this.employee);

            this.form.email = this.employee.email ? this.employee.email : this.form.email;
            this.form.notifications_email = this.notifications_email;
            this.form.employee_url = this.employee.employee_url;

            let response = await ws.sendContract(this.form);

            if(response.type == "success"){
                this.$toast.success(response.message);

                this.closeModal();

                this.$emit('refresh', response.data);
            }
            else{
                this.$toast.error(response.message);
            }
        },
        closeModal(){
            this.$refs.closeSendContractModal.click();
        }
    }
}
</script>